import React, { useContext, useRef } from "react";
import { MainContext } from "../App";
import CloseIcon from "../icons/CloseIcon";

function OrderNotes() {
	const { setPopupVisible, cart, setCart } = useContext(MainContext);
	const notesRef = useRef();

	const saveNotes = (e) => {
		e.preventDefault();
		let tempCart = { ...cart };
		tempCart.notes = notesRef.current.value;
		setCart(tempCart);
		setPopupVisible(false);
	};

	return (
		<div className="popup popup-small">
			<form className="container order-notes" onSubmit={saveNotes}>
				<header>
					<div>Nota generale ordine</div>
					<button
						type="button"
						className="btn btn-tertiary btn-square"
						onClick={() => setPopupVisible(false)}
					>
						<CloseIcon />
					</button>
				</header>
				<div className="content">
					<div className="text-box order-notes-field">
						<textarea
							ref={notesRef}
							defaultValue={cart?.notes}
							placeholder="Scrivi qui eventuali indicazioni per la cucina"
						/>
					</div>
				</div>
				<div className="footer">
					<button className="btn btn-primary btn-block">
						<div>
							<div>Salva note</div>
						</div>
					</button>
				</div>
			</form>
		</div>
	);
}

export default OrderNotes;
